import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AsePage from "@/pages/AsePage";
import BlankPage from "@/pages/BlankPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BlankPage />} />
          <Route path="/ase" element={<AsePage />} />
          <Route path="*" element={<BlankPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
